import { CSSProperties } from "react";
import ButtonSymphony from "elements/ButtonSymphony";
import Icon from "elements/Icon";
import Colors from "modules/Colors";
import { clsx, styx } from "modules/Utils";
import Sty from "modules/Sty";
import useScreen from "Hooks/useScreen";

const BUTTON_HEIGHT_MEDIUM = 72;
const BUTTON_HEIGHT_LARGE = 96;

interface PlatformStartButtonProps {
    className?: string;
    style?: CSSProperties;
    title: string;
    description?: string;
    icon: string;
    link?: string;
    fullWidth?: boolean;
    onClick?: () => void;
    size?: 'medium' | 'large';
    isBorder?: boolean;
    color?: string;
    disabled?: boolean;
}

const PlatformStartButton = ({
    className,
    style,
    title,
    description,
    icon,
    link,
    onClick,
    fullWidth,
    size = 'medium',
    isBorder = true,
    color,
    disabled = false,
}: PlatformStartButtonProps) => {
    const {
        mobileView,
        mStyle
    } = useScreen()

    const buttonHeight = size === 'medium' ? BUTTON_HEIGHT_MEDIUM : BUTTON_HEIGHT_LARGE;

    const handleClick = () => {
        if (disabled) return;
        if (onClick) onClick();
    }

    const platformButton = (
        <div
            className={clsx(
                "platformStartButtonContainer",
                className
            )}
            style={styx(
                sty.platformStartButtonContainer,
                { border: isBorder ? Sty.border : 'none' },
                disabled && sty.platformStartButtonContainerDisabled,
                style,
            )}
            onClick={handleClick}
        >
            <div
                className="platformStartButtonIconContainer"
                style={styx(
                    sty.platformStartButtonIconContainer,
                    color ? { background: color } : null,
                    { height: buttonHeight }
                )}
            >
                <Icon
                    className="platformStartButtonIcon"
                    style={{ flexShrink: 0 }}
                    icon={icon}
                    size={50}
                />
            </div>
            <div
                className="platformStartButtonContent"
                style={styx(
                    mStyle(sty, 'platformStartButtonContent'),
                    fullWidth && { width: '100%' },
                    { height: buttonHeight }
                )}
            >
                <div
                    className="platformStartButtonTitle"
                    style={mobileView ? Sty.text16bold : Sty.text18bold}
                >
                    {title}
                </div>
                {description &&
                    <div
                        className="platformStartButtonDescription"
                        style={mobileView ? Sty.text12grey : Sty.text14grey}
                    >
                        {description}
                    </div>
                }
            </div>

            <ButtonSymphony
                className="platformStartButton"
                style={sty.platformStartButton}
                onClick={() => { }}
                variant="text"
                size={mobileView ? 'small' : 'medium'}
                disabled={disabled}
            >
                {disabled ? 'Unavailable' : 'Start'}
            </ButtonSymphony>
        </div>
    )

    // if (link) {
    //     return (
    //         <Link to={link} style={{ width: fullWidth ? '100%' : 'auto' }}>
    //             {platformButton}
    //         </Link>
    //     )
    // }

    return platformButton;
}

const sty: Record<string, CSSProperties> = {
    platformStartButtonContainer: {
        cursor: 'pointer',
        display: 'flex',
        alignItems: 'center',
        borderRadius: 16,
        overflow: 'hidden',
        paddingRight: 16,
        backgroundColor: 'white',
        flexShrink: 0,
    },
    platformStartButtonIconContainer: {
        display: 'flex',
        flexShrink: 0,
        alignItems: 'center',
        justifyContent: 'center',
        backgroundColor: Colors.purpleLighter,
        height: BUTTON_HEIGHT_MEDIUM,
        paddingLeft: 16,
        paddingRight: 16,
    },
    platformStartButtonContent: {
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        paddingLeft: 24,
        paddingRight: 24,
        backgroundColor: 'white',
        height: BUTTON_HEIGHT_MEDIUM,
    },
    platformStartButtonContent_mobile: {
        paddingLeft: 8,
        paddingRight: 8,
    },
    platformStartButtonContainerDisabled: {
        opacity: 0.7,
        cursor: 'not-allowed',
        backgroundColor: Colors.greyLighter,
    }
}

export default PlatformStartButton;